import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_LABELS,
  DELETE_LABEL,
  GET_LABEL,
  GET_LABELS,
  GET_LABEL_TYPES,
  UPDATE_LABEL,
} from 'setup/redux/Actions/Label/ActionTypes/ApiActionTypes'
import {
  DELETE_ALL_LABELS,
  GENERATE_STUDENT_LABEL_REPORT,
  GENERATE_TEACHER_HOUSE_COLOR_REPORT,
} from 'setup/redux/Actions/School/Labels/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_LABELS, fetchData)
  yield takeEvery(GET_LABEL, fetchData)
  yield takeEvery(GET_LABEL_TYPES, fetchData)
  yield takeEvery(CREATE_LABELS, fetchData)
  yield takeEvery(UPDATE_LABEL, fetchData)
  yield takeEvery(DELETE_LABEL, fetchData)
  yield takeEvery(GENERATE_STUDENT_LABEL_REPORT, fetchData)
  yield takeEvery(GENERATE_TEACHER_HOUSE_COLOR_REPORT, fetchData)
  yield takeEvery(DELETE_ALL_LABELS, fetchData)
}

export default dataSaga
